/* @flow */
import * as React from 'react';

import './AvatarWithTextItems.scss';

type Props = {
  children?: any,
};

export default function AvatarWithTextItems({ children }: Props) {
  return <div className="AvatarWithTextItems">{children}</div>;
}
